import type { Content } from '../../models';

import { VisualsWithDataTypes } from '../../config/constants';
import { getBorderObject, getFormatShadowObject } from '../style';

export const validateContentVersion64 = (content: Content): boolean => {
  const { type, typeSpecific } = content;

  if (typeSpecific.version < 64) {
    if (VisualsWithDataTypes.includes(type) && typeSpecific.style?.colors2) {
      typeSpecific.style.colors2.continuous.colorSets = typeSpecific.style.colors2.continuous.colorSets ?? [];
    }

    // Stacked bar chart total sum
    if (VisualsWithDataTypes.includes(type) && typeSpecific.chart) {
      typeSpecific.chart.values.sumStackedTotal = typeSpecific.chart.values.sumStackedTotal ?? false;
    }

    // Check for search reset button options
    if (typeSpecific.map?.search) {
      if (!typeSpecific.map.search.resetButton) {
        typeSpecific.map.search.resetButton = {
          icon: 'plus r45',
          color: '',
          borderRadius: 0,
          background: {
            backgroundColor: null,
            backgroundImage: null,
          },
          boxShadow: getFormatShadowObject(),
          hoverStyle: {
            color: '',
            borderRadius: 0,
            background: {
              backgroundColor: null,
              backgroundImage: null,
            },
            boxShadow: getFormatShadowObject(),
          },
        };
      }

      if (typeSpecific.map.search.style && !typeSpecific.map.search.style.items.noMatch) {
        typeSpecific.map.search.style.items.noMatch = {
          color: undefined,
          background: {
            backgroundColor: null,
            backgroundImage: null,
          },
        };
      }

      if (typeSpecific.map.search.style && !typeSpecific.map.search.style.container.border) {
        typeSpecific.map.search.style.container.border = getBorderObject();
      }

      if (!typeSpecific.map.search.noMatchFoundMessage) {
        typeSpecific.map.search.noMatchFoundMessage = 'Es gibt leider keinen Treffer zu der eingegebenen Adresse';
      }
    }

    typeSpecific.version = 64;
  }

  return true;
};
